<template>
  <div class="task-list-warpper">
    <div class="task-box">
      <div v-for="(task,num) in selfData.course" :key="task.name" class="card-box task-card ab-center" @click="handleEdit(1, task, num)">
        <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove('course', num)">
        <div class="title">{{ task.name }}</div>
      </div>
      <div v-for="(task,num) in selfData.uaEvent" :key="task.name" class="card-box task-card task-card-2 ab-center" @click="handleEdit( 2, task, num)">
        <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove('uaEvent',num)">
        <div class="title">{{ task.name }}</div>
      </div>
      <div v-for="(task,num) in selfData.taskBodyTestDetailsVOS" :key="'taskBodyTestDetailsVOS'+num" class="card-box task-card task-card-3 ab-center" @click="handleEdit( 3, task, num)">
        <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove('taskBodyTestDetailsVOS', index)">
        <div class="title">{{ task.name || "" }}</div>
      </div>
      <div v-for="(task,num) in selfData.userDefinedTaskDetailVOS" :key="'userDefinedTaskDetailVOS'+num" class="card-box task-card task-card-4" @click="handleEdit( 4, task, num)">
        <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove('userDefinedTaskDetailVOS',num)">
        <img :src="task.converImage" alt="" class="photo">
        <div class="title">{{ task.name || "" }}</div>
        <div v-if="task.content" class="description">
          {{ task.content }}
        </div>
        <div v-if="task.linkTo" class="link">{{ task.linkTo }}</div>
      </div>
      <div v-for="(task,num) in selfData.running" :key="task.name" class="card-box task-card task-card-5 ab-center" @click="handleEdit( 5, task, num)">
        <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove('running',num)">
        <div class="title">{{ task.name }}</div>
      </div>
      <div class="card-box only-add" @click="handleAdd">
        <i class="el-icon-plus" />
        <div>添加任务</div>
      </div>
    </div>
    <el-dialog v-if="showAdd" title="添加任务" :close-on-click-modal="false" :visible="showAdd" custom-class="add-dialog" @close="handleCloseAddOrEdit">
      <el-form ref="formAdd" :model="addForm" :rules="rules" label-width="110px">
        <div class="header">
          <el-form-item label="任务类型">
            <el-radio-group v-model="addForm.type" @change="reset">
              <el-radio :label="1">课程</el-radio>
              <el-radio :label="2">活动</el-radio>
              <!-- <el-radio :label="3">体测</el-radio> -->
              <el-radio :label="4">自定义</el-radio>
              <el-radio :label="5">跑步/骑行活动</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="content">
          <template v-if="addForm.type === 1">
            <div class="top">
              <div class="title">选择课程</div>
              <div class="search">
                <el-input v-model="search" class="fix" placeholder="请输入课程名称" prefix-icon="el-icon-search" style="170px;" />
                <el-button type="primary" @click="searchSubmit(1)">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </div>
            <el-table ref="searchTable" class="searchTable" size="small" :data="searchList" style="width: 100%">
              <el-table-column prop="id" label="课程ID" />
              <el-table-column prop="coverImage" label="课程图片">
                <template v-slot="{ row }">
                  <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                </template>
              </el-table-column>
              <el-table-column prop="name" label="课程名称" />
              <el-table-column label="操作">
                <template v-slot="{ row }">
                  <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="select(row)">选择</el-button>
                  <el-button v-else size="small" type="text" disabled style="cursor: not-allowed">已选择</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else-if="addForm.type === 2">
            <div class="top">
              <div class="title">选择活动</div>
              <div class="search">
                <el-input v-model="search" class="fix" placeholder="请输入活动名称" prefix-icon="el-icon-search" style="170px" />
                <el-button type="primary" @click="searchSubmit(2)">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </div>
            <el-table ref="searchTable" class="searchTable" size="small" :data="searchList" style="width: 100%">
              <el-table-column prop="id" label="活动ID" />
              <el-table-column prop="coverImage" label="活动图片">
                <template v-slot="{ row }">
                  <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                </template>
              </el-table-column>
              <el-table-column prop="name" label="活动名称" />
              <el-table-column label="操作">
                <template v-slot="{ row }">
                  <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="select(row)">选择</el-button>
                  <el-button v-else size="small" type="text" disabled style="cursor: not-allowed">已选择</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else-if="addForm.type === 3">
            <div class="top">
              <div class="title">选择体测</div>
              <el-form-item>
                <el-radio-group v-model="addForm.taskBodyTest.content" :style="addForm.taskBodyTest.content ==2 ?'marginTop:27px;':'margin:27px 0;'" @change="handleRadioChange">
                  <el-radio :label="2">全套完整体测</el-radio>
                  <el-radio :label="0">体测：徒手深蹲</el-radio>
                  <el-radio :label="1">体测：卷腹摸膝</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="addForm.taskBodyTest.content !== 2" label="挑战时长" prop="taskBodyTest.duration" class="fixLabel">
                <el-input v-model.number="addForm.taskBodyTest.duration" size="small" class="fix" oninput="value=value.replace(/[^0-9]/g,'')" style="width:86px;margin-left: -34px;" />&nbsp;秒
              </el-form-item>
              <el-form-item label="上传任务图片" class="upload-box" prop="taskBodyTest.converImage" style="margin-top:20px;">
                <div class="tips">
                  支持上传*.png、*.jpg；大小不超过5M；尺寸：360px*576px
                </div>
                <el-upload ref="tbtUploaderImage" action="" class="avatar-uploader" :on-change="handlePushTBTUploader" :auto-upload="false" :show-file-list="false">
                  <template v-if="addForm.taskBodyTest.converImage">
                    <img :src="addForm.taskBodyTest.converImage" class="avatar">
                    <div class="update">更换图片</div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="addForm.type === 4">
            <div class="top">
              <div class="title" style="margin-bottom: 20px">
                添加自定义任务
              </div>
              <el-form-item label="任务名称" class="custom-item" prop="name">
                <el-input v-model="addForm.name" class="fix" maxlength="10" placeholder="请输入任务名称，最多10个字" />
              </el-form-item>
              <el-form-item label="任务描述" class="custom-item" prop="content">
                <el-input v-model="addForm.content" class="fix" maxlength="15" placeholder="请输入任务描述，最多15个字" />
              </el-form-item>
              <el-form-item label="任务链接" class="custom-item" prop="linkTo">
                <el-input v-model="addForm.linkTo" class="fix" placeholder="请输入任务链接" />
              </el-form-item>
              <el-form-item label="上传任务图片" class="upload-box" prop="converImage">
                <div class="tips">
                  支持上传*.png、*.jpg；大小不超过5M；尺寸：360px*576px
                </div>
                <el-upload ref="uploaderImage" action="" class="avatar-uploader" :on-change="handlePushUploader" :auto-upload="false" :show-file-list="false">
                  <template v-if="addForm.converImage">
                    <img :src="addForm.converImage" class="avatar">
                    <div class="update">更换图片</div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="addForm.type === 5">
            <div class="top">
              <div class="title">选择活动</div>
              <div class="search">
                <el-input v-model="search" class="fix" placeholder="请输入活动名称" prefix-icon="el-icon-search" style="170px" />
                <el-button type="primary" @click="searchSubmit(5)">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </div>
            <el-table ref="searchTable" class="searchTable" size="small" :data="searchList" style="width: 100%">
              <el-table-column prop="id" label="活动ID" />
              <el-table-column prop="coverImage" label="活动图片">
                <template v-slot="{ row }">
                  <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                </template>
              </el-table-column>
              <el-table-column prop="name" label="活动名称" />
              <el-table-column label="操作">
                <template v-slot="{ row }">
                  <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="select(row)">选择</el-button>
                  <el-button v-else size="small" type="text" disabled style="cursor: not-allowed">已选择</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="footer">
          <el-button type="primary" @click="handleAddConfirm">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog v-if="showEdit" title="编辑任务" :close-on-click-modal="false" :visible="showEdit" custom-class="add-dialog edit-dialog" @close="handleCloseAddOrEdit">
      <el-form ref="formEdit" :model="addForm" :rules="rules" label-width="110px">
        <div class="content">
          <template v-if="addForm.type === 1">
            <el-table class="searchTable" classref="searchTable" size="small" :data="currentEdit" style="width: 100%">
              <el-table-column prop="id" label="课程ID" />
              <el-table-column prop="coverImage" label="课程图片">
                <template v-slot="{ row }">
                  <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                </template>
              </el-table-column>
              <el-table-column prop="name" label="课程名称" />
            </el-table>
            <div class="top" style="margin-top: 15px">
              <div class="title">替换课程</div>
              <div class="search">
                <el-input v-model="search" class="fix" placeholder="请输入课程名称" prefix-icon="el-icon-search" style="170px" />
                <el-button type="primary" @click="searchSubmit(1)">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </div>
            <div class="slot">
              <el-table v-if="searchList.length" ref="searchTable" class="searchTable" size="small" :data="searchList" style="width: 100%">
                <el-table-column prop="id" label="课程ID" />
                <el-table-column prop="coverImage" label="课程图片">
                  <template v-slot="{ row }">
                    <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="课程名称" />
                <el-table-column label="操作">
                  <template v-slot="{ row }">
                    <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="replace(row)">选择</el-button>
                    <el-button v-else size="small" type="text" disabled style="cursor: not-allowed">已选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
          <template v-else-if="addForm.type === 2">
            <el-table ref="searchTable" class="searchTable" size="small" :data="currentEdit" style="width: 100%">
              <el-table-column prop="id" label="活动ID" />
              <el-table-column prop="coverImage" label="活动图片">
                <template v-slot="{ row }">
                  <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                </template>
              </el-table-column>
              <el-table-column prop="name" label="活动名称" />
            </el-table>
            <div class="top" style="margin-top: 15px">
              <div class="title">替换活动</div>
              <div class="search">
                <el-input v-model="search" class="fix" placeholder="请输入活动名称" prefix-icon="el-icon-search" style="170px" />
                <el-button type="primary" @click="searchSubmit(2)">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </div>
            <div class="slot">
              <el-table v-if="searchList.length" ref="searchTable" class="searchTable" size="small" :data="searchList" style="width: 100%">
                <el-table-column prop="id" label="活动ID" />
                <el-table-column prop="coverImage" label="活动图片">
                  <template v-slot="{ row }">
                    <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="活动名称" />
                <el-table-column label="操作">
                  <template v-slot="{ row }">
                    <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="replace(row)">选择</el-button>
                    <el-button v-else size="small" type="text" disabled style="cursor: not-allowed">已选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
          <template v-else-if="addForm.type === 3">
            <div class="top">
              <div class="title">选择体测</div>
              <el-form-item>
                <el-radio-group v-model="addForm.taskBodyTest.content" :style="addForm.taskBodyTest.content ==2 ?'marginTop:27px;':'margin:27px 0;'" @change="handleRadioChange">
                  <el-radio :label="2">全套完整体测</el-radio>
                  <el-radio :label="0">体测：徒手深蹲</el-radio>
                  <el-radio :label="1">体测：卷腹摸膝</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="addForm.taskBodyTest.content !== 2" label="挑战时长" prop="taskBodyTest.duration" class="fixLabel">
                <el-input v-model.number="addForm.taskBodyTest.duration" class="fix" size="small" oninput="value=value.replace(/[^0-9]/g,'')" style="width:86px;margin-left: -34px;" />&nbsp;秒
              </el-form-item>
              <el-form-item label="上传任务图片" class="upload-box" prop="taskBodyTest.converImage" style="margin-top:20px;">
                <div class="tips">
                  支持上传*.png、*.jpg；大小不超过5M；尺寸：360px*576px
                </div>
                <el-upload ref="tbtUploaderImage" action="" class="avatar-uploader" :on-change="handlePushTBTUploader" :auto-upload="false" :show-file-list="false">
                  <template v-if="addForm.taskBodyTest.converImage">
                    <img :src="addForm.taskBodyTest.converImage" class="avatar">
                    <div class="update">更换图片</div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="addForm.type === 4">
            <div class="top">
              <el-form-item label="任务名称" class="custom-item" prop="name">
                <el-input v-model="addForm.name" class="fix" maxlength="10" placeholder="请输入任务名称，最多10个字" />
              </el-form-item>
              <el-form-item label="任务描述" class="custom-item" prop="content">
                <el-input v-model="addForm.content" class="fix" maxlength="15" placeholder="请输入任务描述，最多15个字" />
              </el-form-item>
              <el-form-item label="任务链接" class="custom-item" prop="linkTo">
                <el-input v-model="addForm.linkTo" class="fix link" placeholder="请输入任务链接" />
              </el-form-item>
              <el-form-item label="上传任务图片" class="upload-box" prop="converImage">
                <div class="tips">
                  支持上传*.png、*.jpg；大小不超过5M；尺寸：360px*576px
                </div>
                <el-upload ref="uploaderImage" action="" class="avatar-uploader" :on-change="handlePushUploader" :auto-upload="false" :show-file-list="false">
                  <template v-if="addForm.converImage">
                    <img :src="addForm.converImage" class="avatar">
                    <div class="update">更换图片</div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="addForm.type === 5">
            <el-table ref="searchTable" class="searchTable" size="small" :data="currentEdit" style="width: 100%">
              <el-table-column prop="id" label="活动ID" />
              <el-table-column prop="coverImage" label="活动图片">
                <template v-slot="{ row }">
                  <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                </template>
              </el-table-column>
              <el-table-column prop="name" label="活动名称" />
            </el-table>
            <div class="top" style="margin-top: 15px">
              <div class="title">替换活动</div>
              <div class="search">
                <el-input v-model="search" class="fix" placeholder="请输入活动名称" prefix-icon="el-icon-search" style="170px" />
                <el-button type="primary" @click="searchSubmit(5)">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </div>
            </div>
            <div class="slot">
              <el-table v-if="searchList.length" ref="searchTable" class="searchTable" size="small" :data="searchList" style="width: 100%">
                <el-table-column prop="id" label="活动ID" />
                <el-table-column prop="coverImage" label="活动图片">
                  <template v-slot="{ row }">
                    <img :src="row.coverImage" alt="" style="width: 75px; height: 75px">
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="活动名称" />
                <el-table-column label="操作">
                  <template v-slot="{ row }">
                    <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="replace(row)">选择</el-button>
                    <el-button v-else size="small" type="text" disabled style="cursor: not-allowed">已选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </div>
        <div class="footer">
          <el-button type="info" @click="handleCloseAddOrEdit">取消</el-button>
          <el-button type="primary" @click="handleEditConfirm">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import FunctionUtils from "@/utils/functionUtils";
import { getFileType } from "@/common/js/util";
export default {
  props: {
    taskData: {
      type: Object,
    },
  },
  data() {
    return {
      loading: true,
      currentDay: -1,
      currentNum: -1,
      selfData: {},
      showAdd: false, // 添加任务
      showEdit: false, // 编辑任务
      search: "",
      searchList: [],
      courses: [], // 被选择的课程
      events: [], // 被选择的活动
      runnings: [], // 被选择的跑步活动
      typeMap: {
        1: "course",
        2: "uaEvent",
        3: "taskBodyTestDetailsVOS",
        4: "userDefinedTaskDetailVOS",
        5: "running",
      },
      addForm: {
        type: 1,
        content: "",
        converImage: "",
        linkTo: "",
        name: "",
        taskBodyTest: {
          content: 2,
          converImage: '',
          duration: '',
          name: '全套完整体测',
        },
      },
      currentEdit: [],
      rules: {
        name: [{ required: true, message: "请输入任务标题", trigger: "blur" }],
        converImage: [
          { required: true, message: "请上传任务图片", trigger: "change" },
        ],
        "taskBodyTest.duration": [
          { required: true, message: "请填写挑战时长", trigger: "change" },
        ],
        "taskBodyTest.converImage": [
          { required: true, message: "请上传任务图片", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    taskData: {
      handler(newV, old) {
        if (newV) {
          this.selfData = newV;
          this.$emit("change", newV);
        }
        //  else {
        //   const initObj = {
        //     id: 1,
        //     course: [],
        //     uaEvent: [],
        //     taskBodyTestDetailsVOS: [],
        //     userDefinedTaskDetailVOS: [],
        //     running: []
        //   };
        //   this.selfData = initObj;
        //   this.$emit("change", initObj);
        // }
      },

    },
  },
  mounted() {
    const keys = ['course', 'taskBodyTestDetailsVOS', 'uaEvent', 'userDefinedTaskDetailVOS', 'running'];
    const bool = this.hasAllKeys(this.taskData, keys);
    if (bool) {
      this.selfData = this.taskData;
      this.$emit("change", this.taskData);
    } else {
      const initObj = {
        id: 1,
        course: [],
        uaEvent: [],
        taskBodyTestDetailsVOS: [],
        userDefinedTaskDetailVOS: [],
        running: [],
      };
      this.selfData = initObj;
      this.$emit("change", initObj);
    }
  },
  methods: {
    hasAllKeys(obj, keys) {
      for (const key of keys) {
        if (!obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    },

    handleRadioChange(val) {
      const map = {
        '0': '体测：徒手深蹲',
        '1': '体测：卷腹摸膝',
        '2': '全套完整体测',
      };
      if (val === 2) {
        this.addForm.taskBodyTest.duration = '';
      } else {
        this.$refs.formAdd &&
          this.$refs.formAdd.validateField("taskBodyTest.duration");
        this.$refs.formEdit &&
          this.$refs.formEdit.validateField("taskBodyTest.duration");
      }
      this.addForm.taskBodyTest.name = map[val];
    },
    handleRemove(type, num) {
      const data = FunctionUtils.deepClone(this.selfData);
      data[type].splice(num, 1);
      this.selfData = data;
      this.$emit("change", this.selfData);
    },
    handleAdd() {
      this.showAdd = true;
    },
    handleEdit(type, task, num) {
      this.addForm.type = type;
      if (type === 3) {
        this.addForm = {
          ...this.addForm,
          taskBodyTest: {
            ...task,
          },
        };
      }
      if (type === 4) {
        this.addForm = {
          ...this.addForm,
          ...task,
        };
      }
      this.currentNum = num;
      this.currentEdit = [task];
      this.showEdit = true;
    },
    handleCloseAddOrEdit() {
      this.reset();
      this.addForm = {
        type: 1,
        content: "",
        converImage: "",
        linkTo: "",
        name: "",
        taskBodyTest: {
          content: 2,
          converImage: '',
          duration: '',
          name: '全套完整体测',
        },
      };
      this.currentNum = -1;
      this.currentEdit = [];
      this.showAdd = false;
      this.showEdit = false;
    },
    // 体测任务图片上传
    handlePushTBTUploader(file) {
      this.tbtuploader(file);
    },
    tbtuploader(file) {
      if (getFileType(file.raw.name) !== "image") {
        this.$message.error("图片格式不正确");
        this.$refs.tbtUploaderImage.clearFiles();
        return;
      }
      if (parseFloat(file.raw.size / 1024 / 1024) > 5) {
        this.$message.error(`图片大小不能超过5M`);
        this.$refs.tbtUploaderImage.clearFiles();
        return;
      }
      this.asyncImgChecked(file).then(data => {
        if (data) {
          this.$Api.uploadFile
            .uploadImage(file.raw, "taskClock/detail/")
            .then(data => {
              if (data) {
                this.addForm.taskBodyTest.converImage = data;
                this.$refs.formAdd &&
                  this.$refs.formAdd.validateField("taskBodyTest.converImage");
                this.$refs.formEdit &&
                  this.$refs.formEdit.validateField("taskBodyTest.converImage");
              }
            });
        } else {
          return;
        }
      });
    },
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      if (getFileType(file.raw.name) !== "image") {
        this.$message.error("图片格式不正确");
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      if (parseFloat(file.raw.size / 1024 / 1024) > 5) {
        this.$message.error(`图片大小不能超过5M`);
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      this.asyncImgChecked(file).then(data => {
        if (data) {
          this.$Api.uploadFile
            .uploadImage(file.raw, "taskClock/detail/")
            .then(data => {
              if (data) {
                this.addForm.converImage = data;
                this.$refs.formAdd &&
                  this.$refs.formAdd.validateField("converImage");
                this.$refs.formEdit &&
                  this.$refs.formEdit.validateField("converImage");
              }
            });
        } else {
          return;
        }
      });
    },
    asyncImgChecked(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw); // 必须用file.raw
        reader.onload = () => {
          // 让页面中的img标签的src指向读取的路径
          const img = new Image();
          img.src = reader.result;
          const width = 360;
          const height = 576;
          img.onload = () => {
            if (
              img.width !== parseInt(width) ||
              img.height !== parseInt(height)
            ) {
              this.$message.warning(
                `图片大小不匹配，当前文件${img.width}×${img.height}`
              );
              resolve(false);
            } else {
              resolve(true);
            }
          };
        };
      });
    },
    reset() {
      this.search = "";
      this.searchList = [];
      this.courses = [];
      this.events = [];
      this.runnings = [];
    },
    searchSubmit(type) {
      if (!this.search) {
        this.$message.warning(
          `${type === 1 ? "请先输入课程名称!" : "请先输入活动名称！"}`
        );
        return;
      }
      if (type === 1) {
        // 课程
        this.$Api.taskClock.taskCourseSelect(this.search).then(res => {
          this.searchList = res.map(item => {
            return { ...item, isSelected: false };
          });
        });
      } else if (type === 2) {
        // 活动
        this.$Api.taskClock.taskUaEventSelect(this.search).then(res => {
          this.searchList = res.map(item => {
            return { ...item, isSelected: false };
          });
        });
      } else if (type === 5) {
        // 跑步
        this.$Api.taskClock.taskRunningSelect(this.search).then(res => {
          this.searchList = res.map(item => {
            return { ...item, isSelected: false };
          });
        });
      }
    },
    async handleAddConfirm() {
      const newList = FunctionUtils.deepClone(this.selfData);
      const test = () => {
        return new Promise((resolve, reject) => {
          this.$refs.formAdd.validate(valid => {
            if (valid) {
              resolve(true);
            } else {
              reject(false);
            }
          });
        });
      };
      // 如果是自定义任务
      if (this.addForm.type === 4) {
        let data = null;
        try {
          data = await test();
        } catch (error) {
          data = error;
        }
        if (!data) return;
        if (newList.userDefinedTaskDetailVOS) {
          if (Array.isArray(newList.userDefinedTaskDetailVOS)) {
            newList.userDefinedTaskDetailVOS.push(this.addForm);
          }
        } else {
          newList.userDefinedTaskDetailVOS = [this.addForm];
        }
      }
      // 如果是体测
      if (this.addForm.type === 3) {
        let data = null;
        try {
          data = await test();
        } catch (error) {
          data = error;
        }
        if (!data) return;
        if (newList.taskBodyTestDetailsVOS) {
          if (Array.isArray(newList.taskBodyTestDetailsVOS)) {
            newList.taskBodyTestDetailsVOS.push(this.addForm.taskBodyTest);
          }
        } else {
          newList.taskBodyTestDetailsVOS = [this.addForm.taskBodyTest];
        }
      }
      console.log(newList, 'newList');
      if (this.courses?.length) {
        this.courses.forEach(item => {
          newList.course.push(item);
        });
      }
      if (this.events?.length) {
        this.events.forEach(item => {
          newList.uaEvent.push(item);
        });
      }
      if (this.runnings?.length) {
        this.runnings.forEach(item => {
          newList.running.push(item);
        });
      }
      this.selfData = newList;
      this.$emit("change", this.selfData);
      this.handleCloseAddOrEdit();
    },
    handleEditConfirm() {
      const edit = this.$refs.formEdit;
      if (edit) {
        edit.validate((valid) => {
          if (valid) {
            const type = this.typeMap[this.addForm.type];
            const newList = FunctionUtils.deepClone(this.selfData);
            if (this.addForm.type === 1 || this.addForm.type === 2 || this.addForm.type === 5) {
              const data = this.searchList.find(item => item.isSelected);
              if (data) {
                newList[type][this.currentNum] = data;
              }
            } else if (this.addForm.type === 3) {
              newList[type][this.currentNum] = this.addForm.taskBodyTest;
            } else {
              newList[type][this.currentNum] = this.addForm;
            }
            this.selfData = newList;
            this.$emit("change", this.selfData);
            this.handleCloseAddOrEdit();
          }
        });
      }
    },
    select(row) {
      row.isSelected = true;
      if (this.addForm.type === 1) {
        this.courses.push(row);
      } else if (this.addForm.type === 2) {
        this.events.push(row);
      } else if (this.addForm.type === 5) {
        this.runnings.push(row);
      }
    },
    replace(row) {
      this.searchList.forEach(item => {
        item.isSelected = false;
        if (item.id === row.id) {
          item.isSelected = true;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes rotate {
  100% {
    transform: rotate(0deg);
  }
}
.task-list-warpper {
  div {
    box-sizing: border-box;
  }
  .ab-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading-box {
    display: flex;
    color: #9b9b9b;
    cursor: not-allowed;
    .loading {
      position: relative;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      transform: rotate(360deg);
      animation: rotate 45s infinite linear;
      margin-right: 12px;
      &::before {
        position: absolute;
        content: "";
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        box-sizing: border-box;
        border-radius: 50%;
        border-top: 3px solid #e3e3e5;
        border-left: 3px solid #e3e3e5;
        border-bottom: 3px solid transparent;
        border-right: 3px solid transparent;
        transform: rotate(720deg);
        animation: rotate 3s infinite ease-out;
      }
      &::after {
        position: absolute;
        content: "";
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        box-sizing: border-box;
        border-radius: 50%;
        border-bottom: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 7px solid #fff;
        border-left: 7px solid #fff;
        transform: rotate(720deg);
        animation: rotate 3s infinite ease-in-out;
      }
    }
  }
  .task-box {
    max-width: 1400px;
    display: flex;
    flex-wrap: wrap;
    .card-box {
      width: 180px;
      height: 154px;
      border-radius: 4px;
      background: #e3e3e5;
      margin-right: 10px;
      margin-bottom: 10px;
      &.only-add {
        background: #f7f7f7;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        color: #bbb;
        &:hover {
          color: #000;
        }
      }
    }
    .task-card {
      position: relative;
      cursor: pointer;
      border-top: 4px solid #dc0019;
      padding: 5px 5px 10px 5px;
      background: #e3e3e5;
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #494949;
      &.task-card-1 {
        border-color: #dc0019;
      }
      &.task-card-2 {
        border-color: #caa670;
      }
      &.task-card-3 {
        border-color: #000000;
      }
      &.task-card-4 {
        border-color: #9b9b9b;
      }
      &.task-card-5 {
        border-color: #1890FF;
      }
      .photo {
        width: 81px;
        height: 90px;
      }
      .close {
        display: block;
        width: 13px;
        height: 13px;
        position: absolute;
        right: -6px;
        top: -7px;
        cursor: pointer;
      }
      .link {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .task-box-item {
      width: 200px;
      height: 576px;
      .header {
        width: 200px;
        height: 51px;
        font-family: "Neue Plak";
        display: flex;
        flex-direction: column;
        background: #e3e3e5;
        border: 1px solid #f7f7f7;
        align-items: center;
        justify-content: center;
        .count {
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 18px;
          color: #000000;
        }
        .date {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          color: #494949;
        }
      }
      .content {
        width: 200px;
        height: 525px;
        position: relative;
        flex-direction: column;
        background: #f7f7f7;
        border: 1px solid #e3e3e3;
        .box {
          width: 200px;
          height: calc(100% - 44px);
          padding: 0 10px;
          overflow-y: scroll;
          .task-card {
            position: relative;
            cursor: pointer;
            border-top: 4px solid #dc0019;
            margin-top: 10px;
            padding: 5px 5px 10px 5px;
            background: #e3e3e5;
            font-family: "Noto Sans SC";
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #494949;
            &.task-card-1 {
              border-color: #dc0019;
            }
            &.task-card-2 {
              border-color: #caa670;
            }
            &.task-card-3 {
              border-color: #000000;
            }
            &.task-card-4 {
              border-color: #9b9b9b;
            }
            .photo {
              width: 81px;
              height: 90px;
            }
            .title {
              margin-top: 5px;
            }
            .close {
              display: block;
              width: 13px;
              height: 13px;
              position: absolute;
              right: -6px;
              top: -7px;
              cursor: pointer;
            }
          }
        }
        .add {
          width: 100%;
          height: 44px;
          position: absolute;
          left: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #bbbbbb;
          background: #f7f7f7;
          cursor: pointer;
          user-select: none;
          i {
            font-size: 14px;
            margin-right: 6px;
          }
          &:hover {
            color: #000;
          }
        }
        .only-add {
          width: 200px;
          height: 525px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #bbb;
          user-select: none;
          i {
            font-size: 14px;
            margin-bottom: 6px;
          }
          &:hover {
            color: #000;
          }
        }
      }
    }
  }
}
/deep/.add-dialog {
  margin-top: 8vh !important;
  width: 678px;
  .el-dialog__header {
    background: #000;
    height: 74px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .el-dialog__title {
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 23px;
      color: #ffffff;
    }
    .el-dialog__headerbtn {
      width: 12px;
      height: 12px;
      color: #fff;
      top: 31px;
      .el-icon {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding: 30px;
    .header {
      height: 54px;
      border-bottom: 1px solid #e3e3e5;
    }
    .fixLabel {
      .el-form-item__label {
        text-align: left;
        width: auto;
      }
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .fix {
      .el-input__inner {
        border-color: #dcdfe6 !important;
      }
    }
    .link {
      .el-input__inner {
        text-decoration-line: underline;
      }
    }
    .content {
      margin-top: 20px;
      .top {
        .title {
          height: 20px;
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #000000;
        }
        .search {
          margin-top: 20px;
          margin-bottom: 15px;
          display: flex;
          .el-input {
            width: 170px;
            margin-right: 10px;
          }
        }
        .custom-item {
          display: flex;
          height: 34px;
          line-height: 34px;
          margin-bottom: 20px;
          .el-input {
            .el-input__inner {
              width: 407px;
              max-width: 407px;
              height: 34px;
              line-height: 34px;
            }
          }
        }
        .upload-box {
          display: flex;
          flex-direction: column;
          .el-form-item__label {
            text-align: left;
          }
          .tips {
            font-family: "Noto Sans SC";
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #bbbbbb;
            margin-bottom: 20px;
          }
          .update {
            position: absolute;
            bottom: -30px;
            font-family: "Noto Sans SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #0085d0;
          }
          .img {
            width: 120px;
            height: 120px;
            cursor: pointer;
          }
          .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            // overflow: hidden;
          }
          .avatar-uploader .el-upload:hover {
            border-color: #409eff;
          }
          .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            background: #f7f7f7;
            width: 120px;
            height: 120px;
            line-height: 120px;
            text-align: center;
            &::before {
              color: #bbb;
              font-size: 42px;
              font-weight: 100;
            }
          }
          .avatar {
            width: 120px;
            height: 120px;
            display: block;
          }
        }
      }
      .searchTable {
        .el-table__body-wrapper {
          max-height: 198px;
          overflow-y: scroll !important;
        }
      }
      .slot {
        min-height: 78px;
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 32px;
      .el-button {
        width: 150px;
        height: 50px;
      }
    }
  }
}
/deep/ .edit-dialog {
  .el-dialog__body {
    padding: 0 30px 30px;
  }
}
</style>
